/// <reference path="../../../node_modules/@npmsoluto/types.soluto-tweek.theme/Theme.d.ts" />

export type ThemeProps = {
  theme: Theme;
};

export const partnerTheme: Theme = require('../theme.json');



// WEBPACK FOOTER //
// ./packages/platform-common-ui/theme-provider/index.ts